/** Placeholders while replacing longer tokens before bare UO → ORB. */
const UOC_PLACEHOLDER = '\u0001UOC\u0001';
const UODEX_PLACEHOLDER = '\u0002UODEX\u0002';

/**
 * User-facing label: UO → ORB, UOC → ORBC, UODEX → ORBDEX.
 * Collapses accidental ORBORBC / ORBORBDEX / ORBORB.
 */
export function uoToOrbDisplay(text: string): string {
  if (!text) return text;
  let s = text
    .replace(/UODEX/g, UODEX_PLACEHOLDER)
    .replace(/UOC/g, UOC_PLACEHOLDER)
    .replace(/UO/g, 'ORB')
    .replace(UODEX_PLACEHOLDER, 'ORBDEX')
    .replace(UOC_PLACEHOLDER, 'ORBC');
  s = s.replace(/ORBORB([A-Z]{2,})/g, 'ORB$1');
  s = s.replace(/ORBORB/g, 'ORB');
  return s;
}

/** Token id or symbol (uo, UO, uoc, UOC) → display label. */
export function tokenDisplayLabel(token: string): string {
  const id = token.trim().toLowerCase();
  if (id === 'uo') return 'ORB';
  if (id === 'uoc') return 'ORBC';
  return uoToOrbDisplay(token.trim().toUpperCase());
}

/** Trading pair label, e.g. UO/AP → ORB/AP. */
export function tokenPairDisplay(pair: string): string {
  return pair
    .split('/')
    .map((part) => tokenDisplayLabel(part))
    .join('/');
}
